/* istanbul ignore file */
import Vue from 'vue'
import ALERTING from './ALERTING'
import APPSERVICE from './APPSERVICE'
import DM from './DM'
import CC from './CC'
import DPE from './DPE'
import DS from './DS'
import DWH from './DWH'
import FPAPI from './FPAPI'
import IAM from './IAM'
import KING from './KING'
import LINEAGE from './DM/Lineage'
import ORGANIZATION from './ORGANIZATION'
import BILLING from './BILLING'
import SUPPORT from './SUPPORT'
import ML from './ML'
import QB from './QB'
import QUERY_ADMIN from './QUERY_ADMIN'
import STORAGE from './STORAGE'
import STORE from './STORE'
import NOTEBOOK_MANAGER from './NOTEBOOK-MANAGER'
import QUOTA_MANAGER from './QUOTA-MANAGER'
import LIFECYCLE from './LIFECYCLE'

export default {
  install (app) {
    const API = {
      ALERTING: new ALERTING('ALERTING'),
      APPSERVICE: new APPSERVICE('APPSERVICE'),
      DM: new DM('DM'),
      CC: new CC('CC'),
      DPE: new DPE('DPE'),
      DS: new DS('DS'),
      DWH: new DWH('DWH'),
      FPAPI: new FPAPI('FPAPI'),
      IAM: new IAM('IAM'),
      KING: new KING('KING'),
      LINEAGE: new LINEAGE('DWH'),
      ORGANIZATION: new ORGANIZATION('ORGANIZATION'),
      BILLING: new BILLING('BILLING'),
      SUPPORT: new SUPPORT('FPAPI'),
      ML: new ML('ML'),
      QB: new QB('QB'),
      QUERY_ADMIN: new QUERY_ADMIN('QUERY_ADMIN'),
      STORAGE: new STORAGE('STORAGE'),
      STORE: new STORE('STORE'),
      NOTEBOOK_MANAGER: new NOTEBOOK_MANAGER('NOTEBOOK_MANAGER'),
      QUOTA_MANAGER: new QUOTA_MANAGER('QUOTA_MANAGER'),
      LIFECYCLE: new LIFECYCLE('FPAPI')
    }

    Vue.api = app.config.globalProperties.$api = API
    app.provide('$api', app.config.globalProperties.$api)
  }
}
